// UNUSED WARNING
// const isPrimitiveArray = (obj: any) => {
//     return obj != null
//         && obj.getClass().isArray()
//         && obj.getClass().getComponentType() != null
//         && obj.getClass().getComponentType().isPrimitive();
// }

const generateSearchQuery = (params: any) => {
    if (params === null || params === undefined)
        return undefined;

    const queryParams = Object.keys(params)
        .filter((key) => params[key] != null) // ignore null properties
        .filter(
            (key) =>
                params[key] !== Object(params[key]) ||
                (Array.isArray(params[key]) &&
                    (typeof params[key][0] === "string" ||
                        typeof params[key][0] === "number"))
        ) //primitives only, unless an array
        .filter((key) => params[key].toString().trim() !== "") // ignore empty
        .map((key) => `(${key}: ${params[key].toString().trim()})`)
        .join(" AND ");

    return queryParams === "" ? undefined : queryParams;
};

export {
    generateSearchQuery
}
